import React from 'react'
import {Container, Button } from 'react-bootstrap';

const Resources = () => {
  
  const MinorCutsAndScrapes = () => {
    return (
      <div>
        <h2>Minor Cuts and Scrapes</h2>
        <ol>
          <li>Wash your hands with soap and water.</li>
          <li>
            Wash the cut to prevent infection. Use cool or lukewarm water and a mild soap or cleanser to gently remove dirt or debris.
          </li>
          <li>
            Stop the bleeding. Apply pressure to the cut using a clean washcloth or gauze. Maintain pressure for one to two minutes or until the bleeding stops.
          </li>
          <li>Apply petroleum jelly. This will help keep the wound moist for faster healing. Make sure you apply it continuously until the cut heals. To help prevent the spread of dirt and bacteria, consider using petroleum jelly from a tube instead of a jar.</li>
          <li>If it is a dirty cut or a non-sterile cut, consider using triple antibiotic ointment.</li>
          <li>
            Cover the cut with a sterile bandage. This will help protect the cut and prevent it from reopening. Change the bandage daily, and keep the cut covered until it heals.
          </li>
          <li>Consider taking over-the-counter pain medication. Acetaminophen can help relieve painful cuts.</li>
          <li>Make sure your tetanus vaccination is up to date if your cut is from a dirty or rusty object. If you aren’t sure, contact your primary care doctor.</li>
        </ol>
        <p>
          Most minor cuts heal in one week or less; however, if your cut is longer than three-fourths of an inch, more than a quarter inch deep, or won’t stop bleeding, seek immediate medical attention.
          As your cut heals, if you notice any signs of an infection, such as pus or increased redness, swelling or pain, call your primary care doctor or urgent care.
        </p>
        <Button className='mr-3' href="https://www.aad.org/public/everyday-care/injured-skin/burns/treat-minor-cuts" target="_blank">More Information</Button>
        <Button href="https://www.goodrx.com/health-topic/dermatology/first-aid-to-treat-cuts" target="_blank">First Aid to Treat Cuts</Button>
      </div>
    );
  };
  
  const MinorAbrasions = () => {
    return (
      <div>
        <h2>Minor Abrasions</h2>
        <ol>
          <li>
            Assess the Wound:
            <ul>
              <li>
                For severe cases - if the wound is bleeding heavily and you're unable to stop the bleeding after 10 minutes of direct pressure - call 911 or head to the nearest emergency department.
              </li>
              <li>
                Don't remove an object if it's penetrated the body; leave it in place and call 911.
              </li>
              <li>
                If the wound is superficial, proceed to the next step.
              </li>
            </ul>
          </li>
          <li>
            Clean the Affected Area:
            <ul>
              <li>
                Wash your hands with soap and water before touching any open wounds.
              </li>
              <li>
                Clean the wound with cool to warm water with mild soap. Don't clean the wound with hydrogen peroxide or alcohol. Using hydrogen peroxide or rubbing alcohol to clean an injury can actually harm the tissue and delay healing.
              </li>
              <li>
                Gently remove any dirt, rocks, or debris and try not to scrub the wound.
              </li>
            </ul>
          </li>
          <li>
            Stop Mild Bleeding:
            <ul>
              <li>
                Place sterile gauze or a clean towel over the wound and apply direct pressure with your palm.
              </li>
              <li>
                If the gauze soaks through, keep it in place and add more on top.
              </li>
              <li>
                Continue pressure for a minute or two after the bleeding stops.
              </li>
            </ul>
          </li>
          <li>
            Dress the Wound:
            <ul>
              <li>
                Apply a thin layer of antibacterial ointment such as Neosporin or Bacitracin to the wound.
              </li>
              <li>
                If the wound is minor, you can leave it open to the air until healed.
              </li>
              <li>
                If the wound is in a place like the hands or feet, it will be more likely to get dirty and can be covered with a simple bandage.
              </li>
              <li>
                Change the dressing every day; change it more frequently if it gets dirty.
              </li>
            </ul>
          </li>
        </ol>
        <p>
          If you start to notice redness, drainage (pus), or increasing pain in the area, seek medical attention as these are signs of infection.
        </p>
        <Button href="https://intermountainhealthcare.org/blogs/topics/live-well/2017/10/4-steps-to-treat-abrasions-at-home/" target="_blank">More Information</Button>
      </div>
    );
  };

  const Diarrhea = () => {
    return (
      <div>
        <h2>Diarrhea</h2>
        <p>
          Diarrhea is a condition characterized by loose, watery stools that occur more frequently than usual. It can be caused by various factors, including:
        </p>
        <ul>
          <li>
            Usually, diarrhea happens because of a virus that gets into your gut. Some people call it "intestinal flu" or "stomach flu."
          </li>
          <li>
            Allergies to certain foods.
          </li>
          <li>
            Diseases of the intestines (such as Crohn's disease or ulcerative colitis).
          </li>
          <li>
            Eating foods that upset the digestive system.
          </li>
          <li>
            Infection by bacteria (the cause of most types of food poisoning) or other organisms.
          </li>
          <li>
            Laxative abuse.
          </li>
          <li>
            Running (Some people get "runner's diarrhea" for reasons that aren't clear).
          </li>
          <li>
            Some cancers.
          </li>
          <li>
            Surgery on your digestive system.
          </li>
          <li>
            Trouble absorbing certain nutrients, also called "malabsorption."
          </li>
        </ul>
        <p>
          Most cases of diarrhea are nothing more than a brief inconvenience. However, sometimes they can indicate a serious condition. It is recommended to talk with your doctor if your child has diarrhea for more than 24 hours or if you have it for more than 3 days.
        </p>
        <p>
          More serious symptoms of diarrhea include:
        </p>
        <ul>
          <li>
            Blood or mucus in your stool.
          </li>
          <li>
            Weight loss.
          </li>
        </ul>
        <p>
          If you have watery stools more than three times a day and you're not drinking enough fluids, you could become dehydrated. Dehydration can be a serious problem if it's not treated.
        </p>
        <p>
          When to See a Doctor for Diarrhea:
        </p>
        <ul>
          <li>
            Call your doctor right away if you have blood in your diarrhea or black, tarry stools.
          </li>
          <li>
            A fever that is high (above 101 F) or that lasts more than 24 hours.
          </li>
          <li>
            Diarrhea lasting longer than 2 days.
          </li>
          <li>
            Nausea or throwing up that prevents you from drinking liquids to replace lost fluids.
          </li>
          <li>
            Severe pain in your belly (especially the right lower quadrant) or rear end.
          </li>
          <li>
            Diarrhea after coming back from a foreign country.
          </li>
        </ul>
        <div>
      <h4>Treatment for Diarrhea</h4>
      <p>
        If your case is mild, you may not need to take anything. Adults can take an over-the-counter medicine such as bismuth subsalicylate or loperamide, which you can get as liquids or tablets. It's important to stay hydrated by drinking at least six 8-ounce glasses of fluids each day. Choose electrolyte replacement drinks or soda without caffeine. Chicken broth (without the fat), tea with honey, and sports drinks are also good choices. Instead of drinking liquids with your meals, drink liquids between meals. Sip small amounts of fluids often. Liquid probiotics may also help.
      </p>
      <h4>What to Eat When You Have Diarrhea</h4>
      <p>
        When you have diarrhea, the foods that you eat and the foods that you avoid can be critical to helping you recover quicker. This is where BRAT foods come in.
      </p>
      <p>
        BRAT stands for "bananas, rice, apples, toast." These foods are bland, so they won’t aggravate the digestive system. They’re also binding, so they help firm up stool.
      </p>
      <p>
        For more information on what to eat and what to avoid when you have diarrhea, you can refer to the article:
        <br />
      </p>
    </div>
        <Button className='mr-3' href="https://www.webmd.com/digestive-disorders/digestive-diseases-diarrhea" target="_blank">More Information</Button>
        <Button variant="primary" href="https://www.healthline.com/health/what-to-eat-when-you-have-diarrhea#foods-to-avoid">
          What to Eat When You Have Diarrhea
        </Button>
      </div>
    );
  };  

  const Sunburn = () => {
    return (
      <div>
        <h2>Treatment for Sunburn</h2>
        <ul>
          <li>
            Take a pain reliever: For pain relief, take a nonprescription pain reliever such as ibuprofen (Advil, Motrin IB, others) or acetaminophen (Tylenol, others). Alternatively, try a gel pain reliever that you rub on the skin.
          </li>
          <li>
            Cool the skin: Apply a clean towel dampened with cool tap water to the affected skin, or take a cool bath with added baking soda. Cool the skin for about 10 minutes several times a day.
          </li>
          <li>
            Apply a moisturizer, lotion, or gel: Use soothing products like aloe vera lotion or gel, calamine lotion, or moisturizers. Cool the product in the refrigerator before applying and avoid alcohol-based products.
          </li>
          <li>
            Drink extra water: Stay hydrated by drinking extra water to prevent dehydration.
          </li>
          <li>
            Leave blisters alone: If blisters form, leave them intact to help the skin heal. If a blister breaks, trim off the dead skin with clean small scissors, clean the area with mild soap and water, apply an antibiotic ointment, and cover it with a nonstick bandage.
          </li>
          <li>
            Treat peeling skin gently: As the affected area starts peeling, continue using moisturizer to keep the skin hydrated.
          </li>
          <li>
            Take an anti-itch drug: An oral antihistamine like diphenhydramine (Benadryl, Chlor-Trimeton, others) can help relieve itching as the skin peels and heals.
          </li>
          <li>
            Apply a soothing medicated cream: For mild to moderate sunburn, apply nonprescription 1% hydrocortisone cream to the affected area three times a day for three days. Cool the product in the refrigerator before applying.
          </li>
          <li>
            Treat sunburned eyes: Apply a clean towel dampened with cool tap water and avoid wearing contacts until eye symptoms have resolved. Avoid rubbing your eyes.
          </li>
          <li>
            Protect yourself from further sun exposure: While your sunburn heals, stay out of the sun or use other sun-protection measures. Consider using a product with moisturizers and sunscreen.
          </li>
          <li>
            Avoid applying '-caine' products: Do not use creams with benzocaine as they can irritate the skin or cause an allergic reaction. Benzocaine has been linked to a rare but potentially dangerous condition. Use caution when using benzocaine on children under 2 years old and consult a healthcare provider. Follow recommended doses and consider consulting a healthcare provider before using it.
          </li>
        </ul>
        <p>
Don't use benzocaine on children younger than age 2 without supervision from a health care provider. If you're an adult, never use more than the recommended dose and consider talking with your health care provider before using it.</p>
        <Button className='mr-3' variant="primary" href="https://www.aad.org/public/everyday-care/injured-skin/burns/treat-sunburn">More Information</Button>

          <Button variant="primary" href="https://www.mayoclinic.org/diseases-conditions/sunburn/diagnosis-treatment/drc-20355928">
            Mayo Clinic - Sunburn: Diagnosis & Treatment
          </Button>
          </div>     
    )
  }


const InsectBugBites = () => {
  return (
    <div>
      <h2>Treatment for Insect and Bug Bites</h2>
      <ul>
        <li>
          Move to a safe area: Avoid further bites or stings by moving to a safe area.
        </li>
        <li>
          Remove any stingers: If there's a stinger embedded in the skin, gently remove it using tweezers or scrape it off with a blunt-edged object like a credit card.
        </li>
        <li>
          Wash the area: Gently wash the affected area with soap and water to clean it.
        </li>
        <li>
          Apply cold compress: Apply a cloth dampened with cold water or filled with ice to the bite or sting area for 10 to 20 minutes. This helps reduce pain and swelling.
        </li>
        <li>
          Elevate if necessary: If the bite or sting is on an arm or leg, elevate it to help reduce swelling.
        </li>
        <li>
          Apply topical treatments: Apply calamine lotion, baking soda paste, or 0.5% or 1% hydrocortisone cream to the affected area several times a day until symptoms subside.
        </li>
        <li>
          Take an anti-itch medicine: Reduce itching by taking an oral antihistamine such as cetirizine, fexofenadine (Allegra Allergy, Children's Allegra Allergy), or loratadine (Claritin).
        </li>
        <li>
          Take a nonprescription pain reliever: If needed, take a nonprescription pain reliever to alleviate any pain associated with the bite or sting.
        </li>
      </ul>
      <p>
        Seek medical care if the swelling worsens, the site shows signs of infection, or if you don't feel well.
      </p>

      <div>
      <h4>Bug Bite Prevention Tips</h4>
      <ol>
        <li>
          Use insect repellent: Protect against mosquitoes, ticks, and other bugs by using insect repellent that contains 20 to 30 percent DEET on exposed skin and clothing. Follow the instructions on the repellent and reapply as directed. Apply sunscreen before the repellent and do not use sunscreen that contains insect repellent.
        </li>
        <li>
          Wear appropriate clothing: If you anticipate being outdoors at night or in densely-wooded areas, dress appropriately to prevent bug bites. Cover exposed skin by wearing long-sleeved shirts, pants, socks, and closed shoes. Consider treating outer layers of clothing with insect repellent containing Permethrin.
        </li>
        <li>
          Use bed nets: When sleeping outdoors, use bed nets to protect against mosquitoes. Look for nets that have been pre-treated with pyrethroid insecticide and tuck them under the mattress for maximum protection.
        </li>
        <li>
          Stay informed about outbreaks: Check the CDC Travel Health Notices website for travel warnings and recommendations regarding bug-borne diseases.
        </li>
      </ol>
      </div>
  

        <Button className='mr-3' variant="primary" href="https://www.mayoclinic.org/first-aid/first-aid-insect-bites/basics/art-20056593">
          Mayo Clinic - First Aid: Insect Bites
        </Button>
        <Button variant="primary" href="https://www.aad.org/public/everyday-care/injured-skin/bites/prevent-treat-bug-bites">
          American Academy of Dermatology - Prevent and Treat Bug Bites
        </Button>

    </div>
  );
};

const Sprain = () => {
  return (
    <div>
      <h3>Sprain Treatment</h3>
      <p>
        For immediate self-care of a sprain, you can try the R.I.C.E. approach:
      </p>
      <ul>
        <li>
          Rest: Avoid activities that cause pain, swelling, or discomfort. However, it's important to engage in some physical activity to prevent stiffness.
        </li>
        <li>
          Ice: Even if you plan to seek medical help, apply ice to the affected area immediately. Use an ice pack or a slush bath of ice and water for 15 to 20 minutes at a time, repeating every two to three hours while awake for the first few days after the injury.
        </li>
        <li>
          Compression: To help reduce swelling, wrap the area with an elastic bandage. Start wrapping at the end farthest from your heart, making sure not to wrap too tightly. If you experience increased pain, numbness, or swelling below the wrapped area, loosen the wrap.
        </li>
        <li>
          Elevation: Elevate the injured area above the level of your heart, especially at night, to help reduce swelling. Gravity can assist in this process.
        </li>
      </ul>
      <p>
        Additionally, over-the-counter pain medications such as ibuprofen (Advil, Motrin IB, others) and acetaminophen (Tylenol, others) can be helpful for pain relief.
      </p>
      <p>
        After the first two days, gently begin using the injured area. You should notice a gradual improvement in the joint's ability to support weight or your ability to move without pain. Keep in mind that recovery from sprains can take days to months.
      </p>

        <Button className='mr-3' variant="primary" href="https://www.webmd.com/first-aid/sprains-and-strains-treatment">
          WebMD - Sprains and Strains Treatment
        </Button>

        <Button variant="primary" href="https://www.mayoclinic.org/first-aid/first-aid-sprain/basics/art-20056622">
          Mayo Clinic - First Aid: Sprain
        </Button>
    </div>
  );
};
 
const SplinterRemoval = () => {
  return (
    <div>
      <h3>Splinter Removal</h3>
      <p>
        To remove a splinter, follow these steps:
      </p>
      <ol>
        <li>Wash your hands with soap and water.</li>
        <li>Use tweezers to grab the splinter.</li>
        <li>Carefully pull it out at the same angle it went in.</li>
      </ol>
      <p>
        If the splinter is under the skin or hard to grab, you can try the following approach:
      </p>
      <ol>
        <li>Sterilize a pin or needle by soaking it in rubbing alcohol or placing the tip in a flame.</li>
        <li>Wash your hands with soap.</li>
        <li>Use the pin to gently remove the skin over the splinter.</li>
        <li>Then use the tip of the pin to lift the end of the splinter out.</li>
        <li>You may need to use tweezers to pull out the splinter after you lift it.</li>
      </ol>
      <p>
        After the splinter is removed, wash the area with soap and water, pat it dry (avoid rubbing), and apply antibiotic ointment. If the cut is likely to get dirty, bandage the area.
      </p>

        <Button className='mr-3' variant="primary" href="https://medlineplus.gov/ency/article/002137.htm">
          MedlinePlus - Splinter Removal
        </Button>

        <Button variant="primary" href="https://www.aad.org/public/everyday-care/injured-skin/burns/remove-splinters">
          American Academy of Dermatology - Splinter Removal Tips
        </Button>
 
    </div>
  );
};


  return (
    <Container className='mb-5'>
    <h1 className='mt-3 mb-3'>First Aid</h1>
    <MinorCutsAndScrapes />
    <hr />
    <MinorAbrasions />
    <hr />
    <Diarrhea />
    <hr />
    <Sunburn />
    <hr />
    <InsectBugBites/>
    <hr />
    <Sprain/>
    <hr />
    <SplinterRemoval/>

  </Container>
  )
}

export default Resources